import TenDaysMVPSuccess from './TenDaysMVPSuccess';
export default TenDaysMVPSuccess;
